import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import moment from "moment";
import React from "react";

interface Props {
  file: server.dto.File
  onEditClicked: (file: server.dto.File) => void
  onDeleteClicked: (file: server.dto.File) => void
  canEdit: boolean
}

const UploadedFile = (props: Props) => {
  const { file } = props;

  return <div className="padding-large flex align-center gap">
    <div className="grow1">
      <div>
        <a download href={file.downloadUrl}>{file.fullName
        }</a>
      </div>
      <div title={moment.utc(file.uploadOnUtc).toISOString()} className="text-sublabel">
        {`${RESX.File.UploadedBy} ${file.uploadBy} ${file.uploadOnText}`}
      </div>
    </div>
    <div className="grow1" style={{ textAlign: "right" }}>
      {file.contentLengthText}
    </div>
    {props.canEdit && <>
      <PhosphorTrashButton
        layout="in-square"
        onClick={() => { props.onDeleteClicked(file); }}
      />
      <PhosphorPencilButton
        layout="in-square"
        onClick={() => { props.onEditClicked(file); }}
      />
    </>}
  </div>;
};

export default UploadedFile;
